<template>
	<div class="cents">
		<van-nav-bar :title="$t('qxfp')" left-arrow safe-area-inset-top style="background-color: #1ABC9C;"
			@click-left="goto" />
		<div class="requist">
			<van-field :border="true" clearable size="large" v-model="keyword" :placeholder="$t('sbmhzwz')" />
			<van-button color="#1ABC9C" size="small" @click='questlist'>{{$t('cx')}}</van-button>
		</div>
		<!-- 列表 -->
		<van-list v-model="loading" :finished="finished" :finished-text="$t('mygd')" :loading-text="$t('加载中')"  @load="loadMore">
			<div v-for="item in keyList" :key="item.id" class="personItem">
				<img v-if="item.face_url" :src="headerImgUrl+item.face_url" class="itemImg" />
				<img v-else src="../../images/selectfile.png" class="itemImg" />
				<div class="itemInfoBox">
					<div class="itemInfo" style="margin-bottom: 10px;">
						<div class="itemName">{{item.name}}</div>
						<div class="itemMobile" v-if="item.mobile">({{item.mobile}})</div>
					</div>
					<div class="itemInfo">
						<div class="itemDept">{{$t('sqzt')}}：{{item.approve_state==0?$t('wx'):$t('yx')}}</div>
					</div>
					<div class="itemInfo">
						<div class="itemDept">
							{{$t('tbzt')}}：{{item.is_syn==0?$t('wtb'):item.is_syn==1?$t('rlwtb'):item.is_syn==2?$t('kwtb'):item.is_syn==3?$t('sbmmwtb'):$t('tb')}}
						</div>
					</div>
				</div>
				<div class="checkBox">
					<el-checkbox border size="medium" v-model="item.checked" @change='handleCheck($event,item.id)'>{{$t('xz')}}
					</el-checkbox>
				</div>
			</div>
		</van-list>
		<!-- 底部导航栏 -->
		<div class="navList" v-show="navState">
			<div class="navItem">
				<img src="../../images/cancel.png" class="navItemImg" @click="handleNav(0)" />
				<div class="navItemName">{{$t('qx')}}</div>
			</div>
			<div class="navItem">
				<img src="../../images/allCheck.png" class="navItemImg" @click="handleNav(1)" />
				<div class="navItemName">{{$t('qxqx')}}</div>
			</div>
			<div class="navItem">
				<img src="../../images/empower.png" class="navItemImg" @click="handleNav(2)" />
				<div class="navItemName">{{$t('sq')}}</div>
			</div>
			<div class="navItem">
				<img src="../../images/delete.png" class="navItemImg" @click="handleNav(3)" />
				<div class="navItemName">{{$t('sc')}}</div>
			</div>
		</div>
		<!-- 设备列表 -->
		<div class="pop" v-if="powerPopState" @click="1">
			<!-- title -->
			<div class="popBox">
				<div class="popTitleBox">
					<div class="popTitle">{{$t('qxzsb')}}</div>
					<el-checkbox v-model="allCheckState" @change='allCheck'>{{$t('qxqx')}}</el-checkbox>
				</div>
				<!-- 设备列表 -->
				<div class="deveciBox">
					<div v-for="item in deviceList" class="deviceItem" :key="item.id">
						<div class="deviceItemName">{{item.serial_number}}</div>
						<div>{{item.name}}</div>
						<el-checkbox v-model="item.checked" @change='checkChange($event,item.id)'>{{$t('xz')}}</el-checkbox>
					</div>
					<!-- 分页 -->
					<div class="data-load-more" v-if="deviceCount>15||Math.ceil(deviceCount/15)>1">
						<div @click="goTop">{{$t('syy')}}</div>
						<div style="width: 25px;" @click="pageTop" v-if="pageSizeList[0]!=1">...</div>
						<div class="pageSizeBox">
							<div v-for="(item,index) in pageSizeList" :key="item" style="width: 25px;" @click="handlePageSize(item)" :class="[page_device_index==item?'pageSizeItemState':'']">
								{{item>pageSize?'':item}}
							</div>
						</div>
						<div style="width: 25px;" @click="pageBottom" v-if="pageSize>pageSizeList[4]">...</div>
						<div @click="goBottom">{{$t('xyy')}}</div>
					</div>
				</div>
				<!-- 按钮 -->
				<div class="btnBox">
					<div class="cancelBtn" @click="popCancel(0)">{{$t('qx')}}</div>
					<div class="confirmBtn" @click="popCancel(1)">{{$t('qr')}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	var checkArr = []
	var deviceArr = []
	export default {
		data() {
			return {
				headerImgUrl: "https://web.fondcard.net/static",
				UserInfo: JSON.parse(window.localStorage.getItem("getTokendata")), // 本地缓存 获取用户数据
				keyword: '', // 搜索框 绑定值
				keyList: [], // 列表数组
				page_index: 1,
				page_count: 0,
				loading: false,
				finished: false,
				navState: false, // 底部导航栏状态
				page_device_index: 1, // 设备列表接口index
				allCheckState: false, // 设备全选状态
				deviceList: [], // 设备列表
				powerPopState: false, // 授权设备弹窗
				delState: false, // 授权/删除
				codeList: [], // 授权接口返回的code数组
				deviceCount:0, // 接口返回设备数量
				pageSize:0, // 设备页数
				pageSizeList:[1,2,3,4,5], // 页码
			}
		},
		watch:{
			keyword(newVal){
				if(newVal==''){
					this.keyList = []
					this.finished = false;
					this.getList()
				}
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			// 页码点击
			handlePageSize(index){
				console.log(index,this.pageSize);
				console.log(this.page_index);
				 if(index>this.pageSize){
					return
				};
				this.page_device_index = index;
				if(this.delState){
				  if(checkArr.length==1){
					this.getCheckDeviceList(checkArr[0])
				  }else{
					this.getDeviceList()
				  }
				}else{
				  if(checkArr.length==1){
					this.getMannagerDeviceList(checkArr[0])
				  }else{
					this.getDeviceList()
				  }
				}
			},
			// 上个页码
			pageTop(){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				  item-=5
				  pageArr.push(item)
				})
				this.pageSizeList = pageArr;
			},
			// 下页码
			pageBottom(){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				  item+=5
				  pageArr.push(item)
				})
				this.pageSizeList = pageArr
			},
			// 上一页
			goTop(){
				if(this.deviceCount==0){
				  return
				};
				if(this.page_device_index==1){
				  this.$message.info($t('ysdyy'))
				  return
				};
				this.page_device_index--;
				if(this.page_device_index<this.pageSizeList[0]){
					let pageArr = []
					this.pageSizeList.forEach(item=>{
					item-=5
					pageArr.push(item)
					})
					this.pageSizeList=pageArr,
					this.page_device_index=pageArr[4]
				}
				if(this.delState){
				  if(checkArr.length==1){
					this.getCheckDeviceList(checkArr[0])
				  }else{
					this.getDeviceList()
				  }
				}else{
				  if(checkArr.length==1){
					this.getMannagerDeviceList(checkArr[0])
				  }else{
					this.getDeviceList()
				  }
				}
			},
			// 下一页
			goBottom(){
				if(this.deviceCount==0){
				  return
				}
				if(this.page_device_index==this.pageSize){
				  this.$message.info($t('mygd'))
				  return
				}
				this.page_device_index++;
				if(this.page_device_index>this.pageSizeList[4]){
					let pageArr = []
					this.pageSizeList.forEach(item=>{
					item+=5
					pageArr.push(item)
					})
					this.pageSizeList=pageArr,
					this.page_device_index=pageArr[0]
				}
				if(this.delState){
				  if(checkArr.length==1){
					this.getCheckDeviceList(checkArr[0])
				  }else{
					this.getDeviceList()
				  }
				}else{
				  if(checkArr.length==1){
					this.getMannagerDeviceList(checkArr[0])
				  }else{
					this.getDeviceList()
				  }
				}
			},
			// 弹唱按钮点击
			popCancel(i) {
				if (i == 0) {
					this.powerPopState = false;
					this.deviceList = [];
					this.navState = false;
					this.page_device_index = 1;
					this.codeList = [];
					this.keyList.forEach(item => {
						item.checked = false
					});
					checkArr = [];
					deviceArr = [];
				} else {
					if (this.delState == false) {
						if (deviceArr.length == 0) {
							this.$message({
								message: $t('qxzsqsb'),
								type: 'error'
							});
						} else {
							let deviceStr = deviceArr.toString();
							let personStr = '';
							checkArr.forEach(item => {
								personStr = item.toString()
								this.goPower(deviceStr, personStr)
							})
						}
					}else{
						if (deviceArr.length == 0) {
							this.$message({
								message: $t('qxzsqsb'),
								type: 'error'
							});
						} else {
							let deviceStr = deviceArr.toString();
							let personStr = '';
							checkArr.forEach(item => {
								personStr = item.toString()
								this.delPower(deviceStr, personStr)
							})
						}
					}
				}
			},
			// 授权接口
			goPower(id, person_id) {
				let data = {
					method: 'co.key.manage.person.add',
					id: id,
					manager_id: this.UserInfo.manager_id,
					period_no: 0,
					person_id: person_id,
					del_id: id
				};
				this.$https(data).then(res => {
					this.codeList.push(res.data.code)
					if (this.codeList.length == checkArr.length) {
						if (checkArr.length > 1) {
							if (this.codeList.indexOf(-5) != -1) {
								this.$message.info(this.$t('bftbsb'))
							} else {
								this.$message.info(this.$t('qcktbzt'))
							}
						} else {
							if (res.data.code == -5) {
								this.$message.info(this.$t('tbsbqcs'))
							}else if(res.data.code == 0){
								this.$message.info(this.$t('授权成功'))
							}
							 else {
								this.$message.info(this.$t('qcktbzt'))
							}
						}
						this.codeList = [];
						checkArr = [];
						deviceArr = [];
						this.keyList = [];
						this.page_index = 1;
						this.page_device_index = 1;
						this.getList();
					}
				});
				this.powerPopState = false;
				this.allCheckState = false;
				this.navState = false
			},
			// 删除接口
			delPower(id,person_id){
				let data = {
					method:'co.key.manage.person.del',
					id:id,
					manager_id:this.UserInfo.manager_id,
					person_id:person_id,
				}
				this.$https(data).then(res=>{
					this.codeList.push(res.data.code)
					// console.log(`删除接口返回码：`,res.data.code,this.codeList.length,checkArr.length);
					if (this.codeList.length == checkArr.length) {
						
						if (checkArr.length > 1) {
							// console.log(`删除接口返回码2：`,this.codeList.indexOf(-5));
							if (this.codeList.indexOf(-5) != -1) {
								this.$message.info(this.$t('bfscsb'))
							} else {
								this.$message.info(this.$t('qcktbzt'))
							}
						} else {
							if (res.data.code == -5) {
								this.$message.info(this.$t('scsbqcs'))
							}else if(res.data.code == 0){
								this.$message.info(this.$t('删除成功'))
							}
							 else {
								this.$message.info(this.$t('qcktbzt'))
							}
						}
						this.codeList = [];
						checkArr = [];
						deviceArr = [];
						this.keyList = [];
						this.page_index = 1;
						this.page_device_index = 1;
						this.getList();
					}
				})
				this.powerPopState = false;
				this.allCheckState = false;
				this.navState = false
			},
			// 设备全选
			allCheck(e){
				console.log(e)
				this.deviceList.forEach(item=>{
					item.checked = e
				})
			},
			// 设备列表点击
			checkChange(e, id) {
				console.log(e, id)
				if (e) {
					deviceArr.push(id);
				} else {
					deviceArr.splice(deviceArr.indexOf(id), 1);
				}
				console.log(deviceArr)
			},
			// 导航栏点击
			handleNav(i) {
				if (i == 0) { // 取消
					this.keyList.forEach(item => {
						item.checked = false
					})
					checkArr = []
					this.navState = false
				} else if (i == 1) { // 全选
					checkArr = []
					this.keyList.forEach(item => {
						item.checked = true
						checkArr.push(item.id)
					})
					console.log(checkArr);
				} else if (i == 2) { // 授权
					this.powerPopState = true
					this.delState = false
					if (checkArr.length == 1) {
						this.getMannagerDeviceList(checkArr[0])
					}else{
						this.getDeviceList()
					}
				}else{ // 删除
					this.powerPopState = true;
					this.delState = true;
					if (checkArr.length == 1) {
						this.getCheckDeviceList(checkArr[0])
					}else{
						this.getDeviceList()
					}
				}
			},
			// 单人可授权设备列表
			getMannagerDeviceList(person_id) {
				let data = {
					method: 'co.key.manage.person.list',
					page_index: this.page_device_index,
					page_size: 15,
					serial_number: '',
					agent_id: this.UserInfo.agent_id,
					manager_id: this.UserInfo.manager_id,
					person_id: person_id,
					dept_id: ''
				}
				this.$https(data).then(res => {
					res.data.data.forEach(item => {
						item.checked = false
					})
					res.data.data.forEach(item => {
						deviceArr.forEach(item2=>{
							if(item.id==item2){
								item.checked = true
							}
						})
					})
					console.log(res)
					this.deviceList = res.data.data;
					this.deviceCount = res.data.count;
					this.pageSize = Math.ceil(res.data.count/15);
				})
			},
			// 单人可删除的设备列表
			getCheckDeviceList(person_id){
				let data = {
					method:'co.key.check.person.list',
					page_index:this.page_device_index,
					page_size:15,
					serial_number:'',
					agent_id:this.UserInfo.agent_id,
					manager_id:this.UserInfo.manager_id,
					person_id:person_id,
					dept_id:''
				};
				this.$https(data).then(res => {
					res.data.data.forEach(item => {
						item.checked = false
					})
					res.data.data.forEach(item => {
						deviceArr.forEach(item2=>{
							if(item.id==item2){
								item.checked = true
							}
						})
					})
					console.log(res)
					this.deviceList = res.data.data;
					this.deviceCount = res.data.count;
					this.pageSize = Math.ceil(res.data.count/15);
				})
			},
			// 所有设备列表
			getDeviceList(){
				let data = {
					method : 'co.wx.device.list',
					signature : '',
					user_id : this.UserInfo.user_id,
					keyword: this.keyword,
					page_index : this.page_device_index,
					page_size : 15,
				};
				this.$serve(data).then(res=>{
					res.data.data.forEach(item => {
						item.checked = false
					})
					res.data.data.forEach(item => {
						deviceArr.forEach(item2=>{
							if(item.id==item2){
								item.checked = true
							}
						})
					})
					console.log(res)
					this.deviceList = res.data.data;
					this.deviceCount = res.data.count;
					this.pageSize = Math.ceil(res.data.count/15);
				})
			},
			// 选择框点击
			handleCheck(val, id) {
				console.log(val, id);
				this.keyList.forEach(item => {
					if (id == item.id) {
						console.log(item.id);
						item.checked = val
						console.log(item.checked);
						if (item.checked) {
							checkArr.push(item.id)
							this.navState = true
						} else {
							checkArr.splice(checkArr.indexOf(item.id), 1)

							if (checkArr.length == 0) {
								this.navState = false
							}
						}
						console.log(checkArr)
					}
				})
			},
			// 获取更多列表
			loadMore() {
				console.log('触发');
				this.page_index++;
				this.getList()
				console.log(this.page_index);
			},
			// 列表数据获取
			getList() {
				let data = {
					method: 'co.key.person.list',
					page_index: this.page_index,
					page_size: 15,
					name: this.keyword,
					agent_id: this.UserInfo.agent_id,
					mobile: '',
					manager_id: this.UserInfo.manager_id,
					syn_order_by: 0,
					status_order_by: 0
				}
				this.$https(data).then(res => {
					if (res.data.code == 0) {
						res.data.data.forEach(item => {
							item.checked = false
						})
						this.loading = false;
						this.count = res.data.count
						if (res.data.data.length == 0 || this.count === 0) {
							// 加载结束
							this.finished = true;
							return;
						}

						this.keyList = this.keyList.concat(res.data.data)


						if (this.keyList.length >= this.count) {
							this.finished = true;
						}
					}
				})
			},
			// 搜索查询
			questlist() {

				this.page_index = 1
				this.keyList = []

				this.getList()
			},
			// 页面返回
			goto() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped>
	.data-load-more{
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #eee;
		text-align: center;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
	}
	.pageSizeBox{
		width: 50%;
		display: flex;
		justify-content: space-around;
	}
	.pageSizeItem{
	  width: 50rpx;
	}
	.pageSizeItemState{
	  color: #ff2146;
	  text-decoration: underline;
	}
	.btnBox {
		display: flex;
		justify-content: space-around;
		margin-top: 5px;
	}

	.cancelBtn {
		width: 75px;
		height: 40px;
		background-color: rgba(0, 0, 0, 0.7);
		text-align: center;
		line-height: 40px;
		border-radius: 5px;
		color: #fff;
	}

	.confirmBtn {
		width: 75px;
		height: 40px;
		background-color: #1ABC9C;
		text-align: center;
		line-height: 40px;
		border-radius: 5px;
		color: #fff;
	}

	.pop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 99!important 
	}

	.popBox {
		position: fixed;
		top: 150px;
		left: 40px;
		background-color: #fff;
		width: 300px;
		height: 440px;
		padding: 10px;
		
	}

	.popTitleBox {
		display: flex;
	}

	.popTitle {
		margin-right: 10px;
		font-size: 14px;
		line-height: 22px;
	}

	.deveciBox {
		height: 325px;
		overflow: scroll;
	}

	.deviceItem {
		display: flex;
		border-bottom: 1px solid #ccc;
		padding: 20px;
		justify-content: space-between;
	}

	.navList {
		width: 100%;
		padding: 10px 0;
		position: fixed;
		bottom: -5px;
		display: flex;
		justify-content: space-around;
		background-color: #fff;
		z-index: 98!important;
	}

	.navItem {}

	.navItemImg {
		width: 25px;
		height: 25px;
	}

	.checkBox {
		margin: auto 0;
	}

	.personItem {
		display: flex;
		border-bottom: 1px solid #ccc;
		padding: 10px 0;
	}

	.itemImg {
		width: 65px;
		height: 65px;
		border-radius: 50%;
		margin: 0 16px 0 10px;
	}

	.itemInfoBox {
		padding-top: 10px;
	}

	.itemInfo {
		font-size: 15px;
		display: flex;
		width: 200px;
	}

	.itemName {
		flex: 3;
		display: flex;
		justify-content: flex-start;
	}

	.itemMobile {
		flex: 7;
		display: flex;
		justify-content: flex-start;
	}

	.itemBtn {
		background-color: #1ABC9C;
		width: 60px;
		height: 35px;
		color: #fff;
		border-radius: 5px;
		line-height: 35px;
		text-align: center;
		margin: auto;
		font-size: 14px;
	}

	.requist {
		width: 80%;
		margin: 0 auto;
		margin-top: 30px;
		margin-bottom: 30px;
		display: flex;
		justify-content: space-around;
	}

	.requist>>>.van-cell {
		width: 180px;
		border: 1px solid #ccc;
		padding: 4px 6px;
		border-radius: 4px;
	}

	.cents>>>.van-nav-bar__title {
		color: #fff;
	}

	.cents>>>.van-nav-bar .van-icon {
		color: #fff;
	}
</style>
